<div class="lead-form" [formGroup]="form" *ngIf="!loading; else loadingState">
  <section class="br-form-section">
    <h2>Lead</h2>
    <div class="br-form-row">
      <label for="lead-name">Name</label>
      <div><input id="lead-name" class="br-form-control" formControlName="name" />
        <span class="br-form-row__error" *ngIf="form.get('name')?.touched && form.get('name')?.invalid">Name is required.</span>
      </div>
    </div>
    <div class="br-form-row"><label for="lead-stage">Stage</label>
      <select id="lead-stage" class="br-form-select" formControlName="leadStageId">
        <option [ngValue]="null">{{ stagesLoading ? 'Loading stages...' : 'Select stage' }}</option>
        <option *ngFor="let stage of stages" [ngValue]="stage.id"
                [disabled]="!stage.isActive && stage.id !== form.get('leadStageId')?.value">
          {{ stage.name }}{{ stage.isActive ? '' : ' (Inactive)' }}
        </option>
      </select>
    </div>
    <div class="br-form-row"><label for="lead-owner">Sales rep</label>
      <select id="lead-owner" class="br-form-select" formControlName="salesRepUserId">
        <option [ngValue]="null">{{ repsLoading ? 'Loading owners...' : 'Unassigned' }}</option>
        <option *ngFor="let rep of reps" [ngValue]="rep.id">{{ repName(rep) }}</option>
      </select>
    </div>
    <div class="br-form-row"><label for="lead-types">Business types</label>
      <div>
        <div class="lead-form__chips" *ngIf="chosenBusinessTypes.length">
          <span class="lead-chip" *ngFor="let type of chosenBusinessTypes">
            {{ typeLabel(type.name) }}
            <button type="button" class="lead-chip__remove"
                    [disabled]="form.disabled"
                    [attr.aria-label]="'Remove ' + typeLabel(type.name)"
                    (click)="removeBusinessType(type.id)">&times;</button>
          </span>
        </div>
        <select id="lead-types" class="br-form-select"
                [disabled]="form.disabled || businessTypesLoading"
                (change)="addBusinessType($event)">
          <option value="">{{ businessTypesLoading
            ? 'Loading business types...'
            : 'Add a business type...' }}</option>
          <option *ngFor="let type of addableBusinessTypes" [value]="type.id">
            {{ typeLabel(type.name) }}
          </option>
        </select>
      </div>
    </div>
    <div class="br-form-row"><label for="lead-origin">Origin</label>
      <select id="lead-origin" class="br-form-select" formControlName="origin">
        <option value="manual">Manual</option><option value="inbound">Inbound</option>
        <option value="firstparty">First party</option><option value="import">Import</option>
        <option value="discovery">Discovery</option>
      </select>
    </div>
  </section>

  <section class="br-form-section">
    <h2>Address</h2>
    <div class="br-form-row"><label for="lead-address">Address line 1</label><input id="lead-address" class="br-form-control" formControlName="addressLine1" /></div>
    <div class="br-form-row"><label for="lead-city">City</label><input id="lead-city" class="br-form-control" formControlName="city" /></div>
    <div class="br-form-row"><label for="lead-state">State</label><input id="lead-state" class="br-form-control" formControlName="state" /></div>
    <div class="br-form-row"><label for="lead-postal">ZIP / Postal</label><input id="lead-postal" class="br-form-control" formControlName="postalCode" /></div>
    <div class="br-form-row"><label for="lead-latitude">Latitude</label><input id="lead-latitude" class="br-form-control" type="number" step="any" formControlName="latitude" /></div>
    <div class="br-form-row"><label for="lead-longitude">Longitude</label><input id="lead-longitude" class="br-form-control" type="number" step="any" formControlName="longitude" /></div>
  </section>

  <!-- Was one section called Pipeline. That named the system rather than
       anything in the box, held two different questions at once, and outlived
       the module - this is called Leads everywhere now. The headings match
       the record's, so the form a person edits in and the record they read
       use one vocabulary. -->
  <section class="br-form-section">
    <h2>Value</h2>
    <div class="br-form-row"><label for="lead-probability">Probability</label><input id="lead-probability" class="br-form-control" type="number" min="0" max="1" step="0.01" formControlName="probability" /></div>
    <div class="br-form-row"><label for="lead-revenue">Annual revenue</label><input id="lead-revenue" class="br-form-control" type="number" step="0.01" formControlName="expectedAnnualRevenue" /></div>
    <div class="br-form-row"><label for="lead-contribution">Annual contribution</label><input id="lead-contribution" class="br-form-control" type="number" step="0.01" formControlName="expectedAnnualContribution" /></div>
  </section>

  <section class="br-form-section">
    <h2>Next step</h2>
    <div class="br-form-row"><label for="lead-next-action">Next action</label><input id="lead-next-action" class="br-form-control" formControlName="nextActionType" /></div>
    <div class="br-form-row"><label for="lead-next-due">Next action due</label><input id="lead-next-due" class="br-form-control" type="date" formControlName="nextActionDue" /></div>
  </section>
</div>
<ng-template #loadingState><div class="lead-form__loading"><mat-spinner diameter="32"></mat-spinner></div></ng-template>
